import { MisterIcon } from "@rtel/mister-icons";
import { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

const ReportDownload = ({event, canDownloadCsv, canDownloadExcel}: IReportDownload) => {
	const [downloadFileDropdownVisiblity, setDownloadFileDropdownVisibility] = useState(false);
	const canDownload = canDownloadCsv || canDownloadExcel;
	
	return (
		<>
			{canDownload && (
				<>
					<Dropdown
						isOpen={downloadFileDropdownVisiblity}
						toggle={() => setDownloadFileDropdownVisibility(!downloadFileDropdownVisiblity)}
						className="d-inline-block"
					>
						<DropdownToggle
							tag="span"
						>
							<span 
								className="d-inline-block p-3"
								style={{cursor: "pointer"}}
							>
								<MisterIcon name="Doc2" size="sm" />
							</span>
						</DropdownToggle>
								
						<DropdownMenu className="">
							{canDownloadExcel && (
								<DropdownItem className="ps-3" onClick={() => { event({action: "downloadExcel"}) }} style={{cursor: "pointer"}}>
									Excel (.xlsx)
								</DropdownItem>
							)}

							{canDownloadCsv && (
								<DropdownItem className="ps-3" onClick={() => { event({action: "downloadCsv"}) }} style={{cursor: "pointer"}}>      
									CSV (.csv)
								</DropdownItem>
							)}
						</DropdownMenu>
				</Dropdown>
			</>
		)}
	</>   
	)
}

export default ReportDownload

interface IReportDownload {
	event: (value: IEvent) => void;
    canDownloadExcel: boolean;
    canDownloadCsv: boolean;
}